import * as types from '../constants/jobsConstants';
import * as api from '../../api/api';

export function getJobsSuccess(jobs) {
	return {
		type: types.GET_JOBS_SUCCESS,
		response: jobs
	};
}

export function getJobList(clientId, merchantId) {
	return function (dispatch) {
		return api.get(`jobs/client/${clientId}/merchant/${merchantId}`)
			.then(function (response) {
				dispatch(getJobsSuccess(response));
			}).catch(function (error) {
			});
	};
}


// WEBPACK FOOTER //
// ./app/jobs/actions/jobsActions.js